module.exports = __webpack_public_path__ + "static/img/中国人寿.bc30d87.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/pc/cooperation/outer/中国人寿.png
// module id = FLvn
// module chunks = 0 1 2 9